import { Outlet } from 'react-router-dom'
import BottomNav from './BottomNav'
import Header from './Header'
import AddToHomeScreenBanner from './AddToHomeScreenBanner'
import { useLocation } from 'react-router-dom'
import AiAnalyzeButton from './AiAnalyzeButton'

const ROUTE_TITLES: Record<string, { title: string; showBack: boolean }> = {
  '/': { title: 'タスク', showBack: false },
  '/tasks/new': { title: 'タスク作成', showBack: true },
  '/achievements': { title: '実績', showBack: false },
  '/achievements/new': { title: '実績登録', showBack: true },
  '/trophies': { title: 'トロフィー', showBack: false },
  '/status': { title: 'ステータス', showBack: false },
  '/friends': { title: 'フレンド', showBack: false },
  '/friends/search': { title: 'フレンド検索', showBack: true },
}

export default function Layout() {
  const { pathname } = useLocation()
  const isAchievementDetail = pathname.startsWith('/achievements/') && pathname !== '/achievements/new'
  const isFriendProfile = pathname.startsWith('/friends/') && pathname !== '/friends/search'
  const isDetail = isAchievementDetail || isFriendProfile
  const fallbackTitle = isFriendProfile ? 'プロフィール' : '実績詳細'
  const config = ROUTE_TITLES[pathname] ?? { title: fallbackTitle, showBack: isDetail }

  const isDebug = import.meta.env.VITE_DEBUG === 'true'
  const showAiButton = isDebug && pathname === '/achievements'

  return (
    <div className="flex flex-col h-[calc(100svh-env(safe-area-inset-top))] overflow-hidden max-w-md mx-auto">
      <Header
        title={config.title}
        showBack={config.showBack}
        actions={showAiButton ? <AiAnalyzeButton /> : undefined}
      />
      <AddToHomeScreenBanner />
      <main className="flex-1 overflow-y-auto pb-[calc(3.25rem+env(safe-area-inset-bottom))] px-4">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}
